import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme, Box, Container, useTheme, useMediaQuery } from '@mui/material';

import { AccordionHiring } from '@screens/hiring/AccordionHiring';
import { Toats } from '@components/alerts/Toats';
import { useChangePrice } from '@hooks/useChangePrice';
import { useCarStore } from '@store/carInfoStore';
import { useDriverStore } from '@store/driverInfoStore';
import { useSelectedQuoteStore } from '@store/QuoteStore';
import { useHistory } from 'react-router-dom';
import { useCPStore } from '@store/cpStore';
import { useTokenStore } from '@store/TokenStore';
import { CustomButton } from '@buttons/CustomButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import DraggableFab from '@buttons/DraggableFab';
import { usePolicyStore } from '@store/policyStore';
import { upCRMContact } from '@utils/CRM';
import { useTrackingStore } from '@store/TrackingStore';
import { NameSubstring } from '@utils/utilityFunctions';
import useCoupon from '@hooks/useCoupon';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: '#f5f5f5',
    paddingBottom: '40px',
  },
}));

export const Hiring: React.FC = () => {
  const [success, setSuccess] = useState(false);
  const { cpData } = useCPStore();
  const { tracking } = useTrackingStore();
  const [url, setUrl] = useState<any>('');
  const [loading, setLoading] = useState(false);
  const { searchCP, searchCPInsurance } = useCPStore();
  const { token } = useTokenStore();
  const { car } = useCarStore();
  const { policy } = usePolicyStore();
  const { driver } = useDriverStore();
  const [zip, setZip] = useState<string>(driver.codigoPostal || '');
  const { selectedQuote } = useSelectedQuoteStore();

  const history = useHistory();

  const [showToast, setShowToast] = useState(true);
  const [showErrorToast, setShowErrorToast] = useState(false);

  const classes = useStyles();
  const { breakpoints, palette } = useTheme();

  const isDesktop = useMediaQuery(breakpoints.up('lg'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  
  useCoupon()

  useEffect(() => {
    window.scroll(0, 0);
    selectedQuote.insurance === 'hdi' ||
    selectedQuote.insurance === 'aig' ||
    selectedQuote.insurance === 'aba'
      ? searchCPInsurance(zip, selectedQuote.insurance, token)
      : searchCP(zip, token);
  }, []);

  useChangePrice();

  if (
    car.assembler === '' ||
    driver.codigoPostal === '' ||
    selectedQuote.insurance === undefined
  ) {
    history.push('/insurer-details');
  }

  const sendApi = async () => {
    try {
      setLoading(true);
      let response = await upCRMContact(
        token,
        car,
        driver,
        selectedQuote,
        policy,
        tracking,
        cpData,
        selectedQuote,
        url
      );
      setTimeout(() => {
        if (response.success) {
          setLoading(false);
          setSuccess(true);
        } else {
          setLoading(false);
        }
      }, 1000);
    } catch (e) {
      setLoading(false);
      setSuccess(false);
    }
  };

  const title = (
    <p style={{ margin: 0 }}>
      Hola 👋 <strong>{NameSubstring(driver.name)}</strong> ¿Tienes dudas sobre
      cómo llenar tus datos?
    </p>
  );

  return (
    <div className={classes.root}>
      <Toats
        showToast={showToast}
        setShowToast={setShowToast}
        Text="Toma en cuenta que los datos que nos compartas en esta sección serán los que usaremos para la póliza de tu seguro. Checa que sean los correctos, porque si algo está mal, el cambio sería un rollo más adelante."
        isWarning
      />
      <Toats
        showToast={showErrorToast}
        setShowToast={setShowErrorToast}
        Text="¡Debes llenar todos los campos que son obligatorios! Checa cuál te falta para continuar."
      />
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          marginTop: 100,
          position: 'relative',
        }}
      >
        <CustomButton
          text={'Regresar'}
          onClick={() => history.push('/insurer-details')}
          size={isDesktop ? 'medium' : 'small'}
          variant={'text'}
          startIcon={<KeyboardArrowLeftIcon />}
          style={{
            color: palette.primary.main,
            fontSize: isMobile ? 14 : 16,
            textTransform: 'none',
            fontWeight: 'normal',
            textDecoration: 'underline',
          }}
        />
      </Box>
      <Container maxWidth={'lg'}>
        <Box
          sx={{ flexGrow: 1 }}
          style={{
            marginTop: 10,
            minHeight: '70vh',
            position: 'relative',
          }}
        >
          {car.assembler !== '' &&
            driver.codigoPostal !== '' &&
            selectedQuote.insurance !== undefined && (
              <AccordionHiring
                setShowToast={setShowToast}
                setShowErrorToast={setShowErrorToast}
              />
            )}
        </Box>
      </Container>
      <DraggableFab
        loading={loading}
        success={success}
        action={sendApi}
        title={title}
      />
    </div>
  );
};
